/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import toast from 'react-hot-toast';
import Button from '../Button';
import { PhoneNumberInput } from '../Input';
import { ButtonContainer } from './CampaignFormElements';

const Container = styled.div`
  width: 30vw;
  margin: 0 10px;
  list-style: none;
  /* padding: 0 15px; */
  overflow: auto;
  position: relative;
  padding: 0 10px;
  
  @media screen and (max-width: 991px) {
    width: 50vw;
  }

  @media screen and (max-width: 450px) {
    width: calc(75vw - 20px);
    max-height: 70vh;
  }
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
`;

const NumbersWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0;
  flex-flow: row wrap;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  justify-content: space-between;
  width: 70%;
`;

const NumberDisplay = styled.div`
  font-size: 15px;
  padding: 5px 10px;
`;

const HeaderText = styled.p`
  text-align: center;
  padding-top: 20px;
  font-size: 14px;
`;

const PreviewCampaignModal = ({
  customNumbers,
  setCustomNumbers,
  sendTestCampaign,
  testLoading,
}) => {
  const [addedValue, setAddedValue] = useState('');

  const phoneInputRef = useRef();

  const inputFocus = () => {
    setTimeout(() => {
      const phoneInput = document.querySelector('#phoneInput');

      if (phoneInput) {
        phoneInput.focus();
      }
    }, 0);
  };

  useEffect(() => {
    inputFocus();
  }, []);

  const submitTestCampaign = () => {
    if (customNumbers.length > 0) {
      sendTestCampaign();
      inputFocus();
    } else {
      toast.error('Please add at least 1 number');
    }
  };

  const addNumber = (addedValue) => {
    if (customNumbers.length >= 3) {
      toast.error('You can add up to 3 numbers');
      setAddedValue('');
    } else if (addedValue.length >= 12) {
      setCustomNumbers((oldAdded) => [...oldAdded, addedValue]);
      setAddedValue('');
      inputFocus();
    } else {
      toast.error('Please enter a 10 digit number');
    }
  };
  return (
    <Container>
      <HeaderText>Add up to 3 numbers to send a test of this campaign. URLs will not be shortened in test messages if you have selected to "Track campaign conversions".</HeaderText>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <PhoneNumberInput
          ref={phoneInputRef}
          type="tel"
          header="PHONE NUMBER"
          value={addedValue}
          onChange={(e) => setAddedValue(e.target.value)}
          width="70%"
          required
        />

        <Button
          text="Add"
          type="button"
          height="25px"
          width="70px"
          margin="50px 0 0 20px"
          onClick={() => addNumber(addedValue)}
        />
      </div>
      <>
        {customNumbers.map((item, i) => {
          return (
            <NumbersWrapper key={i}>
              <NumberDisplay>{item}</NumberDisplay>
              <Button
                height="40px"
                type="button"
                background="grey"
                text="X"
                width="fit-content"
                onClick={() => setCustomNumbers((oldAdded) => oldAdded.filter((item, ind) => i !== ind))}
              />
            </NumbersWrapper>
            // </div>
          );
        })}
      </>
      <ButtonContainer noBorder>
        <Button
          text="Send Preview"
          loading={testLoading}
          onClick={() => {
            submitTestCampaign();
          }}
        />
      </ButtonContainer>
    </Container>
  );
};

export default PreviewCampaignModal;
